import { axiosInstance } from "@src/shared/api";
import { LIGIN_API_URL } from "../constants";
import { MigrationUserResponseDto } from "../interfaces/migrationUserResponseDto";

interface AccountMigrationRequestDto {
  login: string;
  new_password: string;
}

export const accountMigration = (data: AccountMigrationRequestDto) =>
  axiosInstance.post<MigrationUserResponseDto>(LIGIN_API_URL.accountMigration(), data);